import type {TrackingEvent} from 'web-app/util/famlytics/types';
import {AddPlanEvents} from 'web-app/util/famlytics/events/invoicing/add-plan.event';
import {AddPurchaseEvents} from 'web-app/util/famlytics/events/invoicing/add-purchase.event';
import {BookPurchaseEvents} from 'web-app/util/famlytics/events/invoicing/book-purchase.event';
import {ApprovePurchaseEvents} from 'web-app/util/famlytics/events/invoicing/approve-purchase.event';
import {SendInvoiceEvents} from 'web-app/util/famlytics/events/invoicing/send-invoice.event';
import {EditPlanEvents} from 'web-app/util/famlytics/events/invoicing/edit-plan.event';
import {PlaygroundEvents} from 'web-app/util/famlytics/events/invoicing/playground.event';

export const InvoicingEvents = {
    ...AddPlanEvents,
    ...BookPurchaseEvents,
    ...ApprovePurchaseEvents,
    ...SendInvoiceEvents,
    ...EditPlanEvents,
    ...AddPurchaseEvents,
    ...PlaygroundEvents,
} satisfies Record<string, TrackingEvent>;
